import Solutions from "@components/industry/Solutions";
import { renderComponent } from "./page_actions";

const industrySolution = () => {
  renderComponent(Solutions);
};

export default industrySolution;
